<template>
  <div class="user-menu">
    <div class="user-info">
      <div class="user-name">{{ userName }}</div>
      <div class="user-email">{{ userEmail }}</div>
    </div>
    <div class="menu-divider"></div>
    <button class="button menu-button" @click.prevent="handleSwitchPractice">
      Switch Practice
    </button>
    <button class="button menu-button" @click.prevent="handleManagePractices">
      Manage Practices
    </button>
    <button class="button menu-button" @click.prevent="handleManageUsers">
      Manage Users
    </button>
    <div class="menu-divider"></div>
    <button class="button menu-button logout-button" @click.prevent="handleLogout">
      Logout
    </button>
  </div>
</template>

<script>
export default {
  name: 'UserMenu',
  props: {
    userName: {
      type: String,
      required: true
    },
    userEmail: {
      type: String,
      required: true
    }
  },
  methods: {
    handleSwitchPractice() {
      this.$emit('switch-practice');
    },
    handleManagePractices() {
      this.$emit('manage-practices');
    },
    handleManageUsers() {
      this.$emit('manage-users');
    },
    handleLogout() {
      this.$emit('logout');
    }
  },
  emits: ['switch-practice', 'manage-practices', 'manage-users', 'logout']
}
</script>

<style scoped>
.user-menu {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: var(--border-radius);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  width: 220px;
  overflow: hidden;
}

.user-info {
  padding: 12px;
}

.user-name {
  font-size: 14px;
  font-weight: 600;
  color: #262626;
  margin-bottom: 4px;
}

.user-email {
  font-size: 13px;
  color: #8c8c8c;
}

.menu-divider {
  height: 1px;
  background-color: #f0f0f0;
  margin: 0;
}

.menu-button {
  width: 100%;
  text-align: left;
  border-radius: var(--border-radius);
  border: none;
  box-shadow: none;
}

.menu-button:hover {
  box-shadow: none;
}

.menu-button:active {
  box-shadow: none;
}

.logout-button {
  color: #cf1322;
}

.logout-button:hover {
  background-color: #fff1f0;
  border-color: transparent;
}
</style>
